import { render, staticRenderFns } from "./ProfileList.vue?vue&type=template&id=431d765b&scoped=true"
import script from "./ProfileList.vue?vue&type=script&lang=ts&setup=true"
export * from "./ProfileList.vue?vue&type=script&lang=ts&setup=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "431d765b",
  null
  
)

export default component.exports